import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getInventoryItems } from "./schema/get-inventory-items";
import { getInventoryMetrics } from "./schema/get-inventory-metrics";
import { getManagedReturnsMetrics } from "./schema/get-managed-returns-metrics";
import { getRefulfillmentMetrics } from "./schema/get-refulfillment-metrics";

export const rpcDefinition = {
  getInventoryItems,
  getInventoryMetrics,
  getManagedReturnsMetrics,
  getRefulfillmentMetrics,
};

export type RedoManagedReturnsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
